import Flickity from 'flickity';

const initFlickityCarousels = (elements) => {
    elements.forEach(el => {
        const flickityOptions = {
            cellAlign: 'center',
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            lazyLoad: true,
            imagesLoaded: true,
        };

        const carousel = new Flickity(el, flickityOptions);
    })
};

export default initFlickityCarousels;